// The Elm worker owns HTTP and the bounded cache. This adapter correlates port
// replies with native consumers such as the Shadow DOM reading engine.
import {t} from './i18n.js';
let worker,requestId=0;
const pending=new Map();
function connection(){
  if(!worker){
    worker=window.Elm.Publications.init();
    worker.ports.publicationResponse.subscribe(result=>{
      const request=pending.get(result.id);if(!request)return;
      pending.delete(result.id);
      if(result.error)request.reject(Error(t('ui-unable-to-load-this-book-download-it-offline-while',{value1:result.status||'offline'})));
      else request.resolve(result.value);
    });
  }
  return worker;
}
export function publishedJson(url,{version='',remember=false}={}){
  return new Promise((resolve,reject)=>{
    const id=++requestId;pending.set(id,{resolve,reject});
    const app=connection();
    // A worker created during another Elm program's effect receives its initial
    // subscriptions after that effect returns. Deliver on the next microtask.
    queueMicrotask(()=>app.ports.publicationRequest.send({id,url:String(url),version,remember}));
  });
}
export function rememberPublished(url,version,value){
  const app=connection();
  queueMicrotask(()=>app.ports.publicationRequest.send({id:0,url:String(url),version,value}));
}
